import React, { memo } from 'react';

import { Popover, Typography } from 'antd';

import { useTheme } from '../../../../context/ThemeProvider';
import { shortenText } from '../../../../shared/utils';
import { IChannel } from '../../../../types/communityTypes';

const overlayInnerStyle: React.CSSProperties = {
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  boxShadow: 'none',
  borderRadius: 12,
  maxWidth: 300,
  maxHeight: 300,
  overflowY: 'auto',
};

const popoverTitleStyle: React.CSSProperties = {
  marginRight: 8,
  cursor: 'pointer',
  padding: '0 4px',
  borderRadius: 4,
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: 12,
  flexShrink: 0,
};

interface Props {
  channels: IChannel[];
  maxCharLength?: number;
  children?: React.ReactNode;
}

const CommunityChannelTitle: React.FC<Props> = ({
  channels,
  maxCharLength,
  children,
}) => {
  const { colors } = useTheme();

  const mangoList = (
    <ul
      style={{
        padding: 0,
        listStyle: 'none',
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}>
      {channels?.slice(1).map((channel) => (
        <li key={channel?._id} style={{ color: colors.BACKGROUND }}>
          {channel?.name}
        </li>
      ))}
    </ul>
  );

  return (
    <div className="community-post-title_container">
      {channels?.length > 0 ? (
        <>
          <Typography.Text
            ellipsis
            style={{
              marginRight: 6,
              fontSize: 13,
              fontWeight: 500,
              color: colors.TEXT3,
            }}>
            {children}
            {maxCharLength
              ? shortenText(channels[0]?.name, maxCharLength, true)
              : channels[0]?.name}
          </Typography.Text>
          {channels?.length > 1 ? (
            <Popover
              content={mangoList}
              overlayInnerStyle={overlayInnerStyle}
              color="rgba(0, 0, 0, 0.8)">
              <Typography.Text
                ellipsis
                style={{
                  ...popoverTitleStyle,
                  color: colors.TEXT3,
                  backgroundColor: colors.BORDER,
                }}
                onClick={(e) => e.stopPropagation()}>
                +{channels?.length - 1}
              </Typography.Text>
            </Popover>
          ) : null}
        </>
      ) : null}
    </div>
  );
};

export default memo(CommunityChannelTitle);
